import {
  createCampaignPlanUrl,
  getCampaignPlanByCampaignIdUrl,
  getCampaignPlanByCityUrl,
  updateCampaignPlanUrl,
  updateCampaignPlanStatusUrl,
  removeCampaignPlanFilterUrl,
  downloadCampaignExcelReportUrl,
} from "../urls/CampaignPlanURL";
import {
  deleteRequest,
  downloadFile,
  sendCreateOrUpdateRequest,
  sendGetRequest,
} from "../utils/api/apiUtils";
import { getToken } from "../utils/token";

export async function getCampaignPlan(campaignId, cityId) {
  const headerParams = {
    "Content-Type": "application/json",
  };

  const url = getCampaignPlanByCityUrl
    .replace(":campaignId", campaignId)
    .replace(":cityId", cityId);

  return sendGetRequest(url, {}, true, headerParams);
}

export async function getCampaignPlanOverview(campaignId) {
  const headerParams = {
    "Content-Type": "application/json",
  };

  const url = getCampaignPlanByCampaignIdUrl.replace(":campaignId", campaignId);

  return sendGetRequest(url, {}, true, headerParams);
}

export async function createCampaignPlan(campaignPlanBean) {
  const headerParams = {
    "Content-Type": "application/json",
  };

  return sendCreateOrUpdateRequest(
    createCampaignPlanUrl,
    campaignPlanBean,
    true,
    "POST",
    headerParams
  );
}

export async function updateCampaignPlan(campaignId, campaignPlanBean) {
  const headerParams = {
    "Content-Type": "application/json",
  };
  const url = updateCampaignPlanUrl.replace(":campaignId", campaignId);

  return sendCreateOrUpdateRequest(
    url,
    campaignPlanBean,
    true,
    "PUT",
    headerParams
  );
}

export async function updateCampaignPlanStatus(campaignId, status) {
  const headerParams = {
    "Content-Type": "application/json",
  };
  const params = {
    status: status,
  };
  const url = updateCampaignPlanStatusUrl.replace(":campaignId", campaignId);
  return sendCreateOrUpdateRequest(url, {}, true, "PUT", headerParams, params);
}

// filters ==> { zoneId: "abc", mediaType: "LHS", routeType: "Ring Road" }
export async function removeCampaignPlanFilterFn(campaignId, filtersObj) {
  const url = removeCampaignPlanFilterUrl.replace(":campaignId", campaignId);

  return deleteRequest(url, {}, true, filtersObj);
}

export async function downloadCampaignExcelReportFn(
  campaignId,
  isPureDooh = false
) {
  const headerParams = {
    Authorization: "Bearer " + getToken(),
  };

  const params = {
    isPureDOOH: isPureDooh,
  };

  return downloadFile(
    downloadCampaignExcelReportUrl.replace(":campaignId", campaignId),
    true,
    headerParams,
    params
  );
}
